import { create } from 'zustand';

const useAuthStore = create((set) => ({
  user: typeof localStorage !== 'undefined' ? JSON.parse(localStorage.getItem('crm_user') || 'null') : null,
  token: typeof localStorage !== 'undefined' ? localStorage.getItem('crm_token') || null : null,
  refreshToken: typeof localStorage !== 'undefined' ? localStorage.getItem('crm_refresh_token') || null : null,

  login: (user, token, refreshToken) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('crm_token', token);
      localStorage.setItem('crm_refresh_token', refreshToken || '');
      localStorage.setItem('crm_user', JSON.stringify(user));
    }
    set({ user, token, refreshToken: refreshToken || null });
  },

  logout: () => {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('crm_token');
      localStorage.removeItem('crm_refresh_token');
      localStorage.removeItem('crm_user');
    }
    set({ user: null, token: null, refreshToken: null });
  },
}));

export default useAuthStore;
